/* eslint-disable react/jsx-no-bind */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import * as imageUtils from '../../utils/imageUtils';

const TrackOfTheWeek = ({track, goto}) => { 
    const getThumbnail = (imageUrl, roleType) => {
        const params = '?width=90&aspectw=1&quality=80&mode=crop&scale=both&format=jpg';
        return imageUtils.getThumbnail(imageUrl, roleType, params);
    };
    return (
        <div className="hblock wow land animated" data-wow-delay="0.5s">
            <button className="btn btn-outline btn-explore transition" onClick={() => goto('/trackofthemonth')}>
                EXPLORE
                <svg className="icon icn-carret transition">
                    <use xlinkHref="#icn-carret" />
                </svg>
            </button>
            <h3 className="head">
                <Link to="/trackofthemonth">
                    <span className="circicon">
                        <svg className="icon icon-staroutline transition">
                            <use xlinkHref="#icn-staroutline" />
                        </svg>
                    </span>
                    TRACK OF THE MONTH
                </Link>
            </h3>
            <div className="trackbox">
                <a href="/trackofthemonth">
                    <img className="artist" src={getThumbnail(track.ImageUrl, track.RoleType)} alt={track.RoleDisplayName} />
                </a>
                <p>
                    The track blowing up our speakers this month is...
                    <strong>'{track.Name}'</strong> by <strong>{track.RoleDisplayName}</strong>! Check it out! <strong><Link to="/trackofthemonth">#newmusic</Link></strong>
                </p>
            </div>
        </div>
    );
};

TrackOfTheWeek.propTypes = {
    track: PropTypes.object.isRequired,
    goto: PropTypes.func.isRequired
};

export default TrackOfTheWeek;